<template>
    <el-dialog :visible.sync="clientEditDialogVisible" @close="$emit('input',false)">
        <el-form :model="clientData" :rules="rules" ref="clientForm">
            <el-row style="margin-bottom: 10px;" :gutter="20">
                <el-col :span="6" :offset="6">
                    <el-form-item prop="secondary_dept" label="销售组">
                        <el-select filterable v-model="clientData.secondary_dept" placeholder="请选择销售组">
                            <el-option v-for="item in Contactoption.dept" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="account_manager_name" label="客户经理">
                        <el-select filterable v-model="clientData.account_manager_name" placeholder="请选择客户经理">
                            <el-option v-for="item in Contactoption.client_manager" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button :loading="loading" type="primary" @click="onSubmit('clientForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {editClientInfo, getClueOption} from "@/api/api"
export default {
    name: "ClientEdit",
    props: {
        value:{
            type: Boolean,
            default:false,
            required: true
        },
        clientInfoDetailFormat: {
            type: Object
        }
    },
    data() {
        return {
            Contactoption: {
                dept: [],
                client_manager: []
            },
            clientEditDialogVisible: false,
            clientData: {
                secondary_dept: "",
                account_manager_name: ""
            },
            rules: {
                secondary_dept: [
                    {required: true, message: "请输入销售组", trigger: 'blur'}
                ],
                account_manager_name: [
                    {required: true, message: "请输入客户经理", trigger: 'blur'}
                ]
            },
            loading: false
        }
    },

    mounted() {
        this.getOptions()
    },

    watch: {
        clientInfoDetailFormat(newVal) {
            this.clientData = JSON.parse(JSON.stringify(newVal))
        },

        value(newVal) {
            this.clientEditDialogVisible = newVal
        }
    },

    methods: {
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log('submit!');
                    this.addClueAction()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        async addClueAction(){
            this.loading = true
            let editList = []
            for (let formKey in this.clientData) {
                if(this.clientData[formKey] !== this.clientInfoDetailFormat[formKey]) {
                    editList.push({
                        key: formKey,
                        new_value: this.clientData[formKey]
                    })
                }
            }
            let postData = {
                client_name: this.clientInfoDetailFormat['client_name'],
                edit_info: editList
            }
            let res = await editClientInfo(postData)
            if(res.respCode&&res.respCode=='000000') {
                this.$message.success(res.respMsg)
                this.$emit('refresh', true)
                this.$nextTick(()=>{
                    this.loading = false
                    this.$emit('input',false)
                })
            }else{
                this.$message.error(res.respMsg)
            }
        },

        async getOptions() {
            let postData = {}
            let res = await getClueOption(postData)
            if (res.respCode&&res.respCode=='000000'){
                let Contactoption = res.respData
                this.Contactoption = Contactoption
            }else{
                this.$message.error(res.respMsg)
            }
        }

    }
}
</script>